export default __webpack_public_path__ + "static/referrer-dark-db1cab348fc596eff64edf6310b3a5da.png";